/*
 * Navigation Logic
 * Dependencies: jQuery, duconData (localized in functions.php)
 */
export function initNavigation() {
  (function ($) {
    // Cache DOM elements
    const $window = $(window);
    const $body = $("body");
    const $navbar = $("#main-navigation");
    const $menuButton = $("#mobile-menu-toggle");
    const $menuIcon = $("#menu-icon-open");
    const $mobileMenu = $("#mobile-menu");

    // Variables
    let prevScrollPos = window.pageYOffset;
    const scrollThreshold = 50;
    let isMenuOpen = false;

    // Use data passed from PHP
    // Force boolean conversion just to be safe
    const isHome = Boolean(duconData.isHome);

    /**
     * 1. Initial State Check
     * If we are NOT on home, the CSS handles the black logo,
     * but we ensure the class is there for JS consistency.
     */
    if (!isHome) {
      $navbar.addClass("site-nav--scrolled");
    }

    /**
     * 2. Scroll Behavior
     */
    $window.on("scroll", function () {
      if (isMenuOpen) return; // Don't hide nav if mobile menu is open

      const currentScrollPos = window.pageYOffset;

      // --- Smart Hide (Slide Up/Down) ---
      if (
        currentScrollPos > prevScrollPos &&
        currentScrollPos > scrollThreshold
      ) {
        $navbar.addClass("site-nav--hidden");
        $body.addClass("nav-is-hidden");
      } else {
        $navbar.removeClass("site-nav--hidden");
        $body.removeClass("nav-is-hidden");
      }

      // --- Background & Logo Swap Logic ---
      if (isHome) {
        // On Homepage: Transparent at top, White > 50px
        if (currentScrollPos > scrollThreshold) {
          $navbar.addClass("site-nav--scrolled");
        } else {
          $navbar.removeClass("site-nav--scrolled");
        }
      } else {
        // On Inner Pages: Always keep white background/black logo
        // We only handle the hide/show logic above.
        $navbar.addClass("site-nav--scrolled");
      }

      prevScrollPos = currentScrollPos;
    });

    /**
     * 3. Mobile Menu Toggle
     */
    $menuButton.on("click", function () {
      isMenuOpen = !isMenuOpen;
      $(this).attr("aria-expanded", isMenuOpen);

      if (isMenuOpen) {
        $body.addClass("menu-is-open");
        $mobileMenu.addClass("is-open");
        $menuIcon.removeClass("fa-bars").addClass("fa-xmark");

        // Optional: Force header to be solid white when menu opens
        $navbar.addClass("site-nav--scrolled");
      } else {
        $body.removeClass("menu-is-open");
        $mobileMenu.removeClass("is-open");
        $menuIcon.removeClass("fa-xmark").addClass("fa-bars");

        // Revert header state if we are at top of homepage
        if (isHome && window.pageYOffset <= scrollThreshold) {
          $navbar.removeClass("site-nav--scrolled");
        }
      }
    });

    /**
     * 4. Submenu Toggle (Mobile/Desktop click)
     */
    $(document).on(
      "click",
      ".menu-item-has-children > a, .submenu-toggle",
      function (e) {
        // Only prevent default on mobile or if you want click-to-open on desktop
        if (window.innerWidth < 1024) {
          e.preventDefault();
          const $trigger = $(this);
          // Look for the submenu (Handles standard WP structure or our custom walker)
          const $submenu = $trigger
            .closest("li")
            .find(
              "> .sub-menu, > .site-nav__sub-menu, > .mobile-menu__sub-menu",
            );

          if ($submenu.length) {
            $submenu.stop(true, true).slideToggle(250);
            const $icon = $trigger.find("i");

            if ($trigger.attr("aria-expanded") === "true") {
              $trigger.attr("aria-expanded", "false");
              $icon.css("transform", "rotate(0deg)");
            } else {
              $trigger.attr("aria-expanded", "true");
              $icon.css("transform", "rotate(90deg)");
            }
          }
        }
      },
    );
  })(jQuery);
}
